import Components from "../javascripts/components";

class PusherBatchActionsReloader {
  constructor(args) {
    this.channel = args.channel;
    this.channel.bind("batch_action.error", (data) => {
      const reason = data.error_reason
        ? `Sorry we are unable to complete your batch action: ${data.error_reason}`
        : "There was a problem applying your actions so some actions may not have finished. We have been notified.";
      this.flashReload(data.project_id, "error", reason);
    });

    this.channel.bind("batch_action.success", (data) => {
      this.flashReload(
        data.project_id,
        "notice",
        "Your actions have been applied successfully!",
      );
    });
  }

  flashReload(projectId, flashType, flashMessage) {
    // Only reload page if we are still on the project's fault index
    if (window.location.pathname === `/projects/${projectId}/faults`) {
      $(".c-actions-dropdown .btn span").text("Reloading Page");
      $.cookie("flash", JSON.stringify([[flashType, flashMessage]]), {
        path: "/",
      });
      window.location.reload();
    } else {
      $(window).trigger("rails:flash", {
        type: flashType,
        message: flashMessage,
      });
    }
  }
}

class PusherOnboarder {
  constructor(args) {
    this.channel = args.channel;
    this.channel.bind("onboarding", (data) => this.onboarding(data));
  }

  onboarding(data) {
    if (data.name === "install") {
      $("#install-progress").addClass("complete");
    }
    const $menu = $("#onboarding_menu");
    if ($menu[0]) {
      const $menuItem = $(`#onboarding_menu [data-step=${data.name}]`);
      if (!$menuItem.is(".complete")) {
        $menuItem.addClass("complete");
        const $badge = $("#onboarding_menu .badge");
        $menu.attr(
          "data-complete-count",
          parseInt($menu.attr("data-complete-count"), 10) + 1,
        );
        $badge.html(
          `${parseInt($menu.attr("data-complete-count"), 10)}/${parseInt($menu.attr("data-count"), 10)}`,
        );
      }
    }
  }
}

class PusherAlerter {
  constructor(args) {
    this.channel = args.channel;
    this.channel.bind("alert", (data) => this.notify(data));
  }

  notify(data) {
    $(window).trigger("rails:flash", {
      type: data.type || "alert",
      message: data.text,
      title: data.title,
      onClick: () => {
        if (data.url) {
          window.open(data.url);
        }
      },
    });
  }
}

class PusherPuller {
  constructor(args) {
    this.pull = this.pull.bind(this);
    this.channel = args.channel;
    this.channel.bind("pull", this.pull);
  }

  pull(data) {
    const $el = $(`[data-pusher-id="${data.id}"]`);
    if ($el.length > 0) {
      $.ajax($el.data("url"), {
        type: "get",
        dataType: "html",
        success: (response) => {
          const mode = $el.data("pusher-mode");

          if (mode === "append") {
            $el.after(response);

            Components.instances.unloadFragment($el.parent());
            Components.collection.loadFragment($el.parent());
          } else {
            Components.instances.unloadFragment($el);
            $el.replaceWith(response);
            Components.collection.loadFragment(
              $(`[data-pusher-id="${data.id}"]`),
            );
          }
        },
      });
    }
  }
}

class PushState {
  constructor(args) {
    this.notify = this.notify.bind(this);
    this.channel = args.channel;
    this.channel.bind("push-state", this.notify);
  }

  notify(data) {
    return $(`[data-push-state-id=${data.id}]`).trigger(
      "push-state",
      data.params,
    );
  }
}

window.initPusher = (pusher, userId) => {
  if (!window.presenceChannel) {
    window.presenceChannel = pusher.subscribe(`presence-user-${userId}`);
  }

  if (!window.pusherBatchActionReloader) {
    window.pusherBatchActionReloader = new PusherBatchActionsReloader({
      channel: window.presenceChannel,
    });
  }

  if (!window.pusherOnboarder) {
    window.pusherOnboarder = new PusherOnboarder({
      channel: window.presenceChannel,
    });
  }
  if (!window.pusherAlerter) {
    window.pusherAlerter = new PusherAlerter({
      channel: window.presenceChannel,
    });
  }
  if (!window.pusherPuller) {
    window.pusherPuller = new PusherPuller({ channel: window.presenceChannel });
  }
  if (!window.pusherPushState) {
    window.pusherPushState = new PushState({ channel: window.presenceChannel });
  }
};
